// Hotjar masks everything typed into form fields unless the field has the
// data-hj-allow attribute (https://help.hotjar.com/hc/en-us/articles/36820034730641).
// We allow all text-entry fields except email and password ones.
const TEXT_INPUT_TYPES = ["text", "search", "tel", "url", "number"]
const SENSITIVE_FIELD_PATTERN = /e-?mail|password|passwd|pwd/i

function textEntryField(field) {
  if (field.tagName === "TEXTAREA") return true
  if (field.tagName !== "INPUT") return false

  const type = (field.getAttribute("type") || "text").toLowerCase()
  return TEXT_INPUT_TYPES.includes(type)
}

function sensitiveField(field) {
  const traits = [
    field.getAttribute("name"),
    field.getAttribute("id"),
    field.getAttribute("autocomplete"),
    field.getAttribute("placeholder"),
  ]

  return SENSITIVE_FIELD_PATTERN.test(traits.filter(Boolean).join(" "))
}

function allowField(field) {
  if (textEntryField(field) && !sensitiveField(field)) {
    field.setAttribute("data-hj-allow", "")
  }
}

export function allowKeystrokeRecording(root) {
  if (root instanceof Element && root.matches("input, textarea")) {
    allowField(root)
  }

  root.querySelectorAll("input, textarea").forEach(allowField)
}

export default function initHotjarKeystrokeRecording() {
  if (typeof window.hj !== "function") return undefined

  allowKeystrokeRecording(document)

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          allowKeystrokeRecording(node)
        }
      })
    })
  })
  observer.observe(document.documentElement, { childList: true, subtree: true })

  return observer
}
